import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { Button } from '../components/ui/button';
import Gallery from '../components/Gallery';

export default function GalleryPage() {
  return (
    <div data-testid="gallery-page" className="pt-20 min-h-screen bg-[#FAF7F2]">
      <section className="bg-[#5C4033] py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <p className="font-serif-alt italic text-[#C8962D] text-lg mb-2">
              Nuestros Espacios
            </p>
            <h1 className="font-serif text-4xl md:text-5xl text-white mb-4">
              ¿Te imaginas disfrutando de La Finca?
            </h1>
            <p className="text-white/80 text-lg max-w-2xl mx-auto">
              Haz de tu próxima celebración o estancia un momento inolvidable. Aparta tu fecha y vive la experiencia de La Finca.
            </p>
          </motion.div>
        </div>
      </section>

      <section className="py-16 md:py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <Gallery />
        </div>
      </section>

      <section className="pb-24">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="font-serif text-3xl md:text-4xl text-[#1A1A1A] mb-4">
            ¿Te gustó lo que viste?
          </h2>
          <p className="text-[#1A1A1A]/70 text-lg mb-8">
            Aparta tu fecha y vive La Finca en persona.
          </p>
          <Link to="/reservar">
            <Button
              data-testid="gallery-reserve-btn"
              size="lg"
              className="bg-[#5C4033] hover:bg-[#3D5A3E] text-white px-12 py-6 text-lg"
            >
              Reservar Ahora
              <ArrowRight className="ml-2 h-5 w-5" />
            </Button>
          </Link>
        </div>
      </section>
    </div>
  );
}
